import React from 'react';

const NoInternet = props => (
  <svg
    width={38}
    height={38}
    viewBox="0 0 38 38"
    preserveAspectRatio="xMidYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.573 19.12a12.102 12.102 0 0 1 17.374 0H8.573Zm20.945-4.177a16.95 16.95 0 0 0-24.329 0h24.329Zm-17.562 9.483a7.264 7.264 0 0 1 10.428 0H11.956Zm13.988-5.306a12.099 12.099 0 0 0-17.371 0h17.37Zm-3.56 5.305a7.264 7.264 0 0 0-10.426 0h10.426Zm-4.582 3.44c1.358 0 2.455 1.125 2.455 2.51 0 1.388-1.098 2.513-2.456 2.513-1.358 0-2.458-1.125-2.458-2.511 0-1.384 1.1-2.509 2.459-2.509v-.003Z"
      stroke="#BCC6CA"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4 34 33.647 4" stroke="#647A85" strokeWidth={5.04} strokeLinecap="square" />
    <path d="M4 34 33.647 4" stroke="#BCC6CA" strokeLinecap="square" />
  </svg>
);

export default NoInternet;
